import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SavedView } from 'app/core/models';
import * as CustomValidator from 'app/shared/directives/custom-validators.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { TsButtonModule } from 'tsui';

@Component({
  selector: 'jupiter-view-form',
  templateUrl: './view-form.component.html',
  styleUrls: ['./view-form.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    ReactiveFormsModule,
    MatLegacyButtonModule,
    TsDialogComponent,
    TsButtonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterSavedViewAddComponent implements OnInit {
  viewForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string; saved_views: SavedView[] },
    public matDialogRef: MatDialogRef<JupiterSavedViewAddComponent>,
  ) {}

  ngOnInit(): void {
    this.viewForm = new FormGroup({
      name: new FormControl(this.data.name ?? '', [
        Validators.required,
        CustomValidator.uniqueNameValidator(this.data.saved_views, 'name'),
      ]),
    });
  }

  save(): void {
    this.viewForm.disable();
    this.matDialogRef.close({ ...this.viewForm.getRawValue() });
  }
}
